export const YOUTUBE_VIDEO_ID = {
  PAYMENT_LINK: "qIsA15jk6xA",
  PAGES_CREATORS: "YfSpX0KZXJA",
  PAGES_SUBSCRIPTIONS: "lkJYoVLAt6c",
  INTEGRATIONS_WEBFLOW: "ogk-_O7PLF4"
};
